import axios from 'axios';
import {store} from '../store/index';

const api = axios.create({
  baseURL:  `${process.env.REACT_APP_URL_API}/api`,
  timeout: 15000,
});

api.interceptors.request.use((config)  => {
  //const token = localStorage.getItem('token');
  const token = store.getState().auth.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch({ type: 'LOGOUT_REQUEST' });
    }
    return Promise.reject(error);
  }
);

export default api;